import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import DatePicker from './DatePicker'
import { isValid } from 'date-fns'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gridGap: theme.spacing(2),
  },
  ctrl: {
    minWidth: 'auto',
    width: '100%',
  },
}))

const commonPickerOptions: Partial<React.ComponentProps<typeof DatePicker>> = {
  views: ['month', 'date'],
  disableFuture: false,
  disablePast: true,
  autoOk: true,
  clearable: true,
  variant: 'dialog',
}

const BoundedDateRange = ({
  id,
  from,
  to,
  onUpdate,
}: {
  id: string
  from?: Date
  to?: Date
  onUpdate: (from?: Date, to?: Date) => void
}) => {
  const [[fromValid, toValid], setValid] = React.useState([true, true])
  const classes = useStyles()
  return (
    <>
      <div className={classes.container}>
        <DatePicker
          id={`${id}-bounded-from`}
          className={classes.ctrl}
          label="From"
          value={from ?? null}
          maxDate={to ?? undefined}
          error={fromValid === false}
          onError={(e) => {
            if (fromValid !== !e) {
              setValid([!e, toValid])
            }
          }}
          onChange={(date) => {
            if (from && !isValid(date)) {
              return onUpdate(undefined, to)
            }
            if (date !== null && isValid(date)) {
              onUpdate(date, to)
            }
          }}
          {...commonPickerOptions}
        />
        <DatePicker
          id={`${id}-bounded-to`}
          className={classes.ctrl}
          label="To"
          value={to ?? null}
          minDate={from ?? undefined}
          error={toValid === false}
          onError={(e) => {
            if (toValid !== !e) {
              setValid([fromValid, !e])
            }
          }}
          onChange={(date) => {
            if (to && !isValid(date)) {
              return onUpdate(from, undefined)
            }
            if (date !== null && isValid(date)) {
              onUpdate(from, date)
            }
          }}
          {...commonPickerOptions}
        />
      </div>
    </>
  )
}

export default BoundedDateRange
